const WEB_LOGIN = "/login";
const LOGIN = "/login/:application?";
const LOGOUT = "/logout";
const REGISTER = "/register";
const REGISTER_CLOUD = "/clouds/application";

const HOME = "/";
const POLICY = "/policy";
const REQUEST_IN_PROGRESS = "/request-in-progress";
const CREATE_REQUEST = "/request-create";
const REQUEST = "/request/:requestId";
const HISTORY = "/history";
const SHIPPERS = "/shippers";
const BUSINESSES = "/businesses";
const PROFILE = "/profile";
const BUSINESS_PROFILE = "/business";
const MELI_PROFILE = "/meli/integration";
const NEW_SHIPPERS_LANDING = "/newshippers/:cloudId?";

const WHATSAPP_URL = process.env.REACT_APP_WHATSAPP_URL;

export const PATHS = {
  WEB_LOGIN,
  LOGIN,
  LOGOUT,
  REGISTER,
  REGISTER_CLOUD,
  HOME,
  POLICY,
  REQUEST_IN_PROGRESS,
  CREATE_REQUEST,
  REQUEST,
  HISTORY,
  SHIPPERS,
  BUSINESSES,
  PROFILE,
  BUSINESS_PROFILE,
  MELI_PROFILE,
  NEW_SHIPPERS_LANDING,
  WHATSAPP_URL,
};
